module.exports = __webpack_public_path__ + "static/media/Dark.baa0fbd3.jpg";